// extracted by mini-css-extract-plugin
export default {"card":"UserInput_card__39Ziu","btn":"UserInput_btn__D6AGN","avatar":"UserInput_avatar__ii90w"};